import React from "react";
import { useSearchParams } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useUserContext } from "../../../contexts/UserContext";
import { useContentfulContext } from "../../../contexts/ContentfulContext";
import AnalyticsDashboard from "../../../components/Dashboard/AnalyticsDashboard";
import PageHeader from "../../../components/UI/PageHeader";
import Card from "../../../components/UI/Card";

const Dashboard = () => {
  const [searchParams] = useSearchParams();
  const activeLabel = searchParams.get('label');

  const { userData } = useUserContext();
  const { content } = useContentfulContext();

  return (
    <main className="stride-page-shell" aria-label="Dashboard">
      <div className="w-full">
        {!activeLabel && (
          <PageHeader
            eyebrow="Platform Overview"
            title={content?.DASHBOARD_MESSAGE?.welcome_message || "Welcome back"}
            description="Manage your tools and monitor performance from your central hub."
            className="mb-8"
          />
        )}

        {userData?.selectedOrganization ? (
          <div className="w-full">
            <AnalyticsDashboard />
          </div>
        ) : (
          <Card variant="default" padding="none" className="py-16 px-6 text-center max-w-lg mx-auto flex flex-col items-center border border-border-subtle shadow-card my-12 bg-white">
            <div className="w-14 h-14 rounded-2xl bg-primary-soft text-primary border border-primary/20 flex items-center justify-center mb-4 shadow-xs">
              <Building2 size={26} />
            </div>
            <h2 className="text-lg font-bold text-stride-heading mb-1.5">
              {content?.DASHBOARD_MESSAGE?.no_organization_selected || "No Organization Selected"}
            </h2>
            <p className="text-sm text-stride-muted max-w-sm">
              Please select an organization from the navigation bar above to view your analytics and performance.
            </p>
          </Card>
        )}
      </div>
    </main>
  );
};

export default Dashboard;
